export default __webpack_public_path__ + "static/plants-cover-4eca1579794b0071458d7cdbf3643825.png";